import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import XCloud from './assets/x-cloud.png';
import XSun from './assets/x-sun.png';
import XPlane from './assets/x-plane.png';
import Cloud1 from './assets/x-cloud-1.png';
import Cloud2 from './assets/x-cloud-2.png';
import Cloud3 from './assets/x-cloud-3.png';
import TicPopUp from 'TicPopUp';
import cn from 'cn';
import en from 'en';
let progressQueue = [];

class ProgressBarComponent extends Component {
  // 进度计时器
  rateTimeout = null;
  prev = Date.now();

  // 随机取进度计时
  randomTimeout = null;

  static defaultProps = {
    message: '正在为您处理...',
    timeOver: '15',
  };

  state = {
    value: 0,
    status: '',
  };

  // 设置当前进度
  setCurRate(value, callback) {
    clearTimeout(this.rateTimeout);
    const { timeOver } = this.props;
    const ms = Math.ceil(100 / Number(timeOver) / 1000);
    this.rateTimeout = setTimeout(() => {
      const oldValue = this.state.value;
      if (oldValue === value) {
        callback && callback();
        return;
      }
      this.setState({ value: oldValue + ms }, () => {
        this.setCurRate(value, callback);
      });
    }, 10);
  }
  // 随机时间更新进度
  randomRate() {
    clearTimeout(this.randomTimeout);
    const { timeOver } = this.props;
    const max = 99;
    let { value } = this.state;
    if (value > max) return;
    const ms = Math.ceil(max / Number(timeOver));
    this.randomTimeout = setTimeout(() => {
      value += ms;
      if (value >= max) value = max;
      this.setCurRate(value, () => {
        this.randomRate();
      });
    }, 1000 /* Math.round(ms + ms * Math.random()) * 1000 */);
  }

  // 设置当前进度
  setCurRate111(value, callback) {
    clearTimeout(this.rateTimeout);
    const curr = Date.now();
    const spac = value === 100 ? 40 : 80;
    const ms = Math.max(0, spac - (curr - this.prev));
    this.rateTimeout = setTimeout(() => {
      const oldValue = this.state.value;
      if (oldValue === value) {
        callback && callback();
        return;
      }
      this.setState({ value: oldValue + 1 }, () => {
        this.setCurRate(value, callback);
      });
    }, ms);
    this.prev = curr + ms;
  }

  // 随机时间更新进度
  randomRate111() {
    clearTimeout(this.randomTimeout);
    const max = 99;
    let { value } = this.state;
    if (value > max) return;
    const ms = Math.ceil(value / 10);
    this.randomTimeout = setTimeout(() => {
      value += Math.round(1 + (10 - ms + 1) * Math.random());
      if (value >= max) value = max;
      this.setCurRate(value, () => {
        this.randomRate();
      });
    }, 1000 /* Math.round(ms + ms * Math.random()) * 1000 */);
  }

  // 开始
  start = () => {
    clearTimeout(this.rateTimeout);
    clearTimeout(this.randomTimeout);
    this.setState({ value: 0, status: '' }, () => {
      this.randomRate();
    });
  };

  success(callback) {
    clearTimeout(this.rateTimeout);
    clearTimeout(this.randomTimeout);
    this.setCurRate(100, () => {
      setTimeout(() => {
        this.setState({ status: 'success' }, () => {
          setTimeout(() => {
            callback && callback();
          }, 1000);
        });
      }, 600);
    });
  }

  fail(callback) {
    clearTimeout(this.rateTimeout);
    clearTimeout(this.randomTimeout);
    this.setState({ status: 'fail' }, () => {
      setTimeout(() => {
        callback && callback();
      }, 1000);
    });
  }

  render() {
    const { value /* , status */ } = this.state;
    const layerStyle = {
      width: `${value}%`,
    };
    return (
      <div className="progress-bar-container">
        <div>
          <img className="progress-bar-sun" src={XSun} alt="" />
          <div className="progress-bar-sm-cloud">
            <img src={Cloud1} alt="" />
            <img src={Cloud2} alt="" />
            <img src={Cloud3} alt="" />
          </div>
          <img className="progress-bar-plane" src={XPlane} alt="" />
          <div className="progress-bar-cloud">
            <img src={XCloud} alt="" />
          </div>
        </div>
        <div className="progress">
          <div className="bar">
            <div style={layerStyle} />
          </div>
          <b>{value}%</b>
        </div>
        <b className="label">{this.props.message}</b>
      </div>
    );
  }

  componentWillMount() {
    this.start();
  }

  componentWillUnmount() {
    clearTimeout(this.rateTimeout);
    clearTimeout(this.randomTimeout);
  }
}

export default function ProgressBar(message, operateType, timeOver) {
  let lang = cn;
  let isEN = window.sessionStorage.getItem('language') == 'en';
  if (isEN) {
    lang = en;
  }
  if (window.sessionStorage.getItem('persist:emp')) {
    lang = JSON.parse(
      JSON.parse(window.sessionStorage.getItem('persist:emp')).App
    ).lang;
  }
  let div = document.createElement('div');
  let s = null;
  document.body.appendChild(div);
  const destroy = () => {
    if (!div) return;
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    compoent = null;
    div = null;
  };

  let compoent = ReactDOM.render(
    <ProgressBarComponent
      {...(message ? { message } : { message: lang.Processing1 })}
      {...{ timeOver }}
    />,
    div
  );

  const success = finished => {
    compoent &&
      compoent.success(() => {
        destroy();
        finished && finished();
      });
  };
  const fail = finished => {
    compoent &&
      compoent.fail(() => {
        destroy();
        finished && finished();
      });
  };
  const overtime = () => {
    let isAIComming = window.sessionStorage.getItem('isAIComming');
    let isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
    let enterUrl = window.sessionStorage.getItem('enterUrl')
      ? window.sessionStorage.getItem('enterUrl')
      : process.env.REACT_APP_APP +
        'ticketRefund/#/ticket/updateDetail?' +
        (isAIComming
          ? 'channel=AI&from=assistant'
          : isAICommingFT
          ? 'channel=AI'
          : '');
    let tip = operateType === 'B' ? lang.Processing2 : lang.Processing3;
    s = setTimeout(() => {
      destroy();
      if (progressQueue.length > 0) {
        window.sessionStorage.setItem('进度条', 'true');
        TicPopUp(
          lang.reminder1,
          tip,
          () => {
            window.sessionStorage.removeItem('进度条');
            window.location.href = enterUrl;
            window.location.reload();
          },
          '',
          [
            {
              text: lang.refCupon33,
              onPress: () => {
                window.sessionStorage.removeItem('进度条');
                window.location.href = enterUrl;
                window.location.reload();
              },
            },
          ],
          '3.85rem'
        );
      }
      clearTimeout(s);
    }, Number(timeOver) * 1000);
  };
  overtime();
  progressQueue.push({
    destroy,
    success,
    fail,
  });
  return progressQueue[progressQueue.length - 1];
}

ProgressBar.clear = () => {
  if (progressQueue && progressQueue.length) {
    progressQueue.forEach(progess => {
      progess.destroy();
    });
    progressQueue = [];
  }
};



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js